<template>
  <el-card
    id="myMiniSurvey"
    v-loading="loading"
    shadow="hover"
    class="clear-card myMiniSurvey"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title defaultCursor"
    >
      <span>{{ $t('pulse.pulseSummary') }}</span>
    </div>
    <div
      class="content"
      :class="session >= 7 ? 'filledData' : ''"
    >
      <div
        v-if="!previewMode && session >= 7 && pulseData"
        class="charts"
      >
        <PulseScoreLeader
          v-if="pulseData"
          key="realPulse"
          :report="pulseData"
          :narrow="true"
        />
      </div>
      <div
        v-else
        class="no-data"
      >
        <PulseScoreLeader
          v-if="!isIE"
          :report="dummyData"
          class="dummyChart"
          :narrow="true"
        />
        <div
          class="noDataOverlay defaultCursor"
          :class="{gray: isIE}"
        >
          {{ $t('pulse.noData') }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  components: {
    PulseScoreLeader: () => import(/* webpackChunkName: "Charts" */ './charts/PulseScoreLeader.vue'),
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      callFlag: false,
      pulseData: null,
      responses: {
        pulse1: null,
        pulse2: null,
      },
      loading: false,
      dummyData: {
        pulse1: {
          self: 4.0,
          manager: 4.3,
          coworker: 4.1,
        },
        pulse2: {
          self: 4.2,
          manager: 4.6,
          coworker: 4.4,
        },
        pulse3: {
          self: 4.5,
          manager: 4.95,
          coworker: 4.8,
        },
      },
    };
  },

  computed: {
    ...mapState({
      session: (state) => state.processStatus.process.session,
    }),

    isIE() {
      return navigator.userAgent.indexOf('MSIE') !== -1
          || navigator.appVersion.indexOf('Trident/') > -1;
    },

    sessionFlag() {
      return !!(this.session && this.session >= 7);
    },
  },

  watch: {
    sessionFlag(newValue) {
      if (newValue && !this.callFlag) {
        this.callFlag = false;
        this.getPulseSimple();
      }
    },
  },

  created() {
    if (this.session >= 7 && !this.callFlag) {
      this.callFlag = false;
      this.getPulseSimple();
    }
  },

  methods: {
    async getPulseSimple() {
      try {
        this.loading = true;
        let pulseData = null;
        const response = await api.getPulseReportLeader({ quick: true });
        if (response && response.data) {
          pulseData = {};
          Object.keys(response.data).forEach((pulse) => {
            const keySort = { self: 1, manager: 2, stakeholder: 3 };
            pulseData[pulse] = {};
            if (response.data[pulse]) {
              Object.keys(response.data[pulse])
                .sort((a, b) => keySort[a] - keySort[b])
                .forEach((key) => {
                  if (key === 'respondent_ct') {
                    this.responses[pulse] = response.data[pulse][key];
                  } else {
                    const newKey = key === 'stakeholder' ? 'coworkers' : key;
                    pulseData[pulse][newKey] = response.data[pulse][key];
                  }
                });
            }
          });
        }
        this.pulseData = pulseData;
      } catch (err) {
        if (err.msg && !['Pulse report is currently not available', 'Report is not ready yet.', 'Pulse Not found']
          .includes(err.msg)) {
          this.$message.error(err.msg);
        }
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#myMiniSurvey {
  height: 100%;

  .title {
    text-align: center;
  }

  &:not(.mobile):not(.tablet) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 120px;
    font-style: italic;
    text-align: center;
    color: #c4c4c4;

    .charts {
      width: 100%;
    }

    .nbRespondent {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: var(--themeFontColor);
      text-align: left;
      margin-left: 25px;

      .subject {
        padding-right: 10px;
      }

      .pulseDivide {
        padding-right: 10px;
      }

      .textBold {
        font-weight: bold;
      }
    }

    .no-data {
      width: 100%;
      position: relative;

      .dummyChart {
        filter: blur(2px) alpha(0.5);
        pointer-events: none;
      }

      .noDataOverlay {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-style: italic;
        top: 0;
        color: var(--themeFontColor);
        width: 100%;
        height: 97%;

        &.gray {
          color: #c4c4c4;
        }
      }
    }
  }
}
</style>

<style lang="scss">
  #myMiniSurvey {
    .el-card__header {
      font-weight: bold;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }
    }
  }
</style>
